/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VIPRDecoratable',
	'./VIPRDataSet'
], function(_, VIPRDecoratable, VIPRDataSet) {

	class VIPRData extends VIPRDecoratable {
		/**
		 * @param {Object[]} queryResults
		 */
		constructor(queryResults, visualization, hideAggTypeInAxisLabels, content) {
			super();

			this.context = {
				version: 0,
				VIPRData: this,
				hideAggTypeInAxisLabels: hideAggTypeInAxisLabels
			};

			this._aVIPRDataSets = [];

			const mappedSlots = visualization.getSlots().getMappedSlotList();
			const datasetIds = visualization.getDefinition().getDatasetList().map(dataset => dataset.id);
			_.each(datasetIds, function(datasetId) {
				const slots = _.filter(mappedSlots, slot => slot.getDefinition().getDatasetIdList().includes(datasetId));
				const queryResult = queryResults.getResult(datasetId);
				if (queryResult) {
					const minmaxResult = queryResults.getResult(datasetId, queryResults.QUERY_RESULT_TYPE.MINMAX);
					if (minmaxResult) {
						this.context.minmaxResult = minmaxResult;
					}
					this._aVIPRDataSets.push(
						new VIPRDataSet(datasetId, queryResult, slots, this.context, content)
					);
				} else {
					this._aVIPRDataSets.push(null);
				}
			}.bind(this));
		}

		getDataSetAt(index) {
			return this._aVIPRDataSets[index];
		}

		getDataSetCount() {
			return this._aVIPRDataSets.length;
		}

		getDecorationsVersion() {
			return this.context.version;
		}
	}

	return VIPRData;
});
